import { GetLanguage } from '@utils/language';
import { encryption } from '@utils/encryption';
import { checkHttpStatus, parseJSON, expiredToken, errorResponse } from '@utils/response';
import { Token, UserCode, AccessType, IsSupervisorMode, Company, EmployeeId, EmployeeCode } from '@users';

const CONTROLLER_ROUTE = IsSupervisorMode() ? 'Supervisor/' : '';

export function getBank(employeeCode, payBankCod) {

    let body = {};
    const url = CONTROLLER_ROUTE + 'bankbalance/getBank';

    if (IsSupervisorMode()) {
        body = JSON.stringify({
            language: GetLanguage(),
            accessTypeCrypt: encryption(AccessType()),
            companyCrypt: encryption(Company()),
            userCodeCrypt: encryption(UserCode()),
            employeeIdCrypt: encryption(0),
            employeeCodeCrypt: encryption(employeeCode),
            payBankCodCrypt: encryption(payBankCod),
            token: Token()
        });
    } else {
        body = JSON.stringify({
            language: GetLanguage(),
            accessTypeCrypt: encryption(AccessType()),
            companyCrypt: encryption(Company()),
            userCodeCrypt: encryption(UserCode()),
            employeeIdCrypt: encryption(EmployeeId()),
            employeeCodeCrypt: encryption(EmployeeCode()),
            token: Token()
        });   
    }    

    return fetch(url, {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getBankVacation(employeeCode) {

    let body = {};
    const url = CONTROLLER_ROUTE + 'bankbalance/getBankVacation';

    if (IsSupervisorMode()) {
        body = JSON.stringify({
            accessTypeCrypt: encryption(AccessType()),
            companyCrypt: encryption(Company()),
            userCodeCrypt: encryption(UserCode()),
            employeeCodeCrypt: encryption(employeeCode),
            token: Token()
        });
    } else {
        body = JSON.stringify({
            accessTypeCrypt: encryption(AccessType()),
            companyCrypt: encryption(Company()),
            userCodeCrypt: encryption(UserCode()),
            employeeCodeCrypt: encryption(EmployeeCode()),
            token: Token()
        });
    }    

    return fetch(url, {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getCurrentBanks(employeeCode) {

    let body = {};
    const url = CONTROLLER_ROUTE + 'bankbalance/getCurrentBanks';

    if (IsSupervisorMode()) {
        body = JSON.stringify({
            language: GetLanguage(),
            accessTypeCrypt: encryption(AccessType()),
            companyCrypt: encryption(Company()),
            userCodeCrypt: encryption(UserCode()),
            employeeCodeCrypt: encryption(employeeCode),
            token: Token()
        });
    } else {
        body = JSON.stringify({
            language: GetLanguage(),
            accessTypeCrypt: encryption(AccessType()),
            companyCrypt: encryption(Company()),
            userCodeCrypt: encryption(UserCode()),
            employeeCodeCrypt: encryption(EmployeeCode()),
            token: Token()
        });       
    }    

    return fetch(url, {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getCurrentBankVacation(employeeCode) {

    let body = {};
    const url = CONTROLLER_ROUTE + 'bankbalance/getCurrentBankVacation';

    if (IsSupervisorMode()) {
        body = JSON.stringify({
            companyCrypt: encryption(Company()),
            accessTypeCrypt: encryption(AccessType()),
            userCodeCrypt: encryption(UserCode()),
            employeeCodeCrypt: encryption(employeeCode),
            token: Token()
        });
    } else {
        body = JSON.stringify({
            companyCrypt: encryption(Company()),
            accessTypeCrypt: encryption(AccessType()),
            userCodeCrypt: encryption(UserCode()),
            employeeCodeCrypt: encryption(EmployeeCode()),
            token: Token()
        });
    }    

    return fetch(url, {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}